// extracted by mini-css-extract-plugin
export default {"container":"LoaderCard_container__rHkde","loadingLine":"LoaderCard_loadingLine__6f6QS","loading":"LoaderCard_loading__HkwbT"};